import { Button, Center } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { Link, Navigate, useParams } from "@tanstack/react-router";

import { useListBrands } from "../../api/generated/endpoints/teams/teams";
import { accessScopeQuery, findTeam } from "../../api/session";
import { ErrorAlert } from "../../platform/ErrorAlert";
import { managesBrands } from "../../platform/permissions";
import { readPref } from "../../platform/prefs";
import { StatusScreen } from "../../ui/StatusScreen";
import { PRO_HOME, SIMPLE } from "./nav";

/**
 * `/teams/$teamId/pro`: the team's first brand's Pro Home, the brand the current nav's links go to
 * (spec ui-perf/pro-studio-redesign, "Routes"). With no brand, says to add one first.
 */
export function Studio2Entry() {
  const { teamId } = useParams({ from: "/signed-in/teams/$teamId/pro" });
  const brands = useListBrands(teamId);
  const role = useQuery({
    ...accessScopeQuery(),
    select: (scope) => findTeam(scope, teamId)?.role,
  }).data;
  if (brands.isError) {
    return (
      <Center p="xl">
        <ErrorAlert error={brands.error} />
      </Center>
    );
  }
  if (brands.data === undefined) return null;
  const first = brands.data[0];
  if (first !== undefined) {
    // Simple when this browser chose it (spec ui-perf/ui-switch-classic-simple-pro), else Pro.
    const to = readPref("ui") === "simple" ? SIMPLE : PRO_HOME;
    return (
      <Navigate
        to={to}
        params={{ teamId, brandId: first.id }}
        search={(prev) => prev}
        hash
        replace
      />
    );
  }
  const manages = role !== undefined && managesBrands(role);
  return (
    <StatusScreen
      title="Add a brand first"
      message={
        manages
          ? "Pro Studio's pages are a brand's, and this team has no brand yet."
          : "Pro Studio's pages are a brand's, and this team has no brand yet. Ask an admin " +
            "to add one."
      }
      action={
        manages ? (
          <Button
            renderRoot={(props) => (
              <Link {...props} to="/teams/$teamId/brands/new" params={{ teamId }} />
            )}
          >
            Add a brand
          </Button>
        ) : undefined
      }
    />
  );
}
